import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@Utils';

import { add_svg } from '@Assets';
import { ConfigurationGs1List, ConfigurationList, NewMasterModal, PageWrapper } from '@Components';
import { TrackedButton } from '@Components/ui-v2/tracked-button';
import { ClientMaster, Gs1ConfigurationLink, Options } from '@Models';
import config from '../../config';

interface ConfigurationProps {
  configurationLinks: Gs1ConfigurationLink[] | ClientMaster[];
  sources: Options[];
  refetch: () => void;
  readOnlyMasters?: boolean;
}

const Configure = ({ configurationLinks, refetch, sources, readOnlyMasters = false }: ConfigurationProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);

  return (
    <div className={cn(loading && 'pointer-events-none animate-pulse', 'h-full w-full')}>
      <PageWrapper
        title={t('Configuration.Title')}
        actions={
          config.createsMasters && (
            <TrackedButton buttonName="OPEN_ADD_USER_WINDOW" isSubmit={false} onClick={() => setOpenAdd(true)}>
              <div className="flex">
                <img src={add_svg} alt="add_master" className="w-4 text-white mr-2" />
                {t('Configuration.AddMaster')}
              </div>
            </TrackedButton>
          )
        }>
        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
          <div className="flex md:flex-row mx-6 my-4 items-center flex-col">
            <span className="font-bold text-xl justify-start text-gray-700">
              {`${t('Configuration.All')} (${configurationLinks?.length ?? 0})`}
            </span>
          </div>
          {config.isGs1Flavor ? (
            <ConfigurationGs1List
              configures={configurationLinks as Gs1ConfigurationLink[]}
              setLoading={setLoading}
              refetch={refetch}
              readOnlyMasters={readOnlyMasters}
            />
          ) : (
            <ConfigurationList
              configures={configurationLinks as ClientMaster[]}
              setLoading={setLoading}
              refetch={refetch}
              readOnlyMasters={readOnlyMasters}
            />
          )}
        </div>
      </PageWrapper>
      <NewMasterModal
        isOpen={openAdd}
        onClose={() => {
          setOpenAdd(false);
        }}
        sources={sources}
        refetch={refetch}
      />
    </div>
  );
};

export default Configure;
